<template>
	<FormGroupBox title="Generales">
		<b-form-row v-if="$hasPermission('reservation.client.generalOptions')">
			<b-form-group class="col-8" label="Cliente">
				<b-form-checkbox
					size="sm"
					class="d-none"
					v-model="clientConfirmed"
					>Reservación Confirmada</b-form-checkbox
				>
				<b-form-checkbox
					disabled
					size="sm"
					v-model="clientEdited"
					>Reservación Editada</b-form-checkbox
				>
			</b-form-group>
		</b-form-row>
		<b-form-row>
			<SelectNumber
				:disabled="!canBeUpdated"
				v-model="adults"
				class="col-4"
				label="Adultos"
			/>
			<SelectNumber
				:disabled="!canBeUpdated"
				v-model="children"
				class="col-4"
				label="Niños"
			/>
			<SelectNumber
				:disabled="!canBeUpdated"
				v-model="infants"
				class="col-4"
				label="Infantes"
			/>
		</b-form-row>
	</FormGroupBox>
</template>

<script>
import SelectNumber from "../helpers/_selectNumber";
import FormGroupBox from "@/components/helpers/FormGroupBox";
import {mapFields} from '../helpers/helpers'
export default {
	components: {
        SelectNumber,
		FormGroupBox
	},
	props: {
		canBeUpdated: Boolean
	},
	computed:{
		//El viewModel principal esta en el modulo reservation de vuex store
		...mapFields({
			fields: ['clientConfirmed','clientEdited','adults','children','infants'],
			base: 'viewModel',
			mutation: 'SET_UPDATE_MODEL',
			module: 'reservation'
		}),
	},
};
</script>

